import { siteConfig } from '../../data/mock';

export const NAV_ITEMS = [
  { path: '/', label: 'Home' },
  { path: '/gallery', label: 'Portfolio' },
  { path: '/#services', label: 'Pricing', isAnchor: true, mobileOnly: true },
  { path: '/about', label: 'About' },
  { path: '/contact', label: 'Contact' },
];

export const INSTAGRAM_URL = `https://instagram.com/${siteConfig.instagram.replace('@', '')}`;

export const scrollToServices = (pathname, navigate) => {
  if (pathname !== '/') {
    navigate('/#services');
    return;
  }
  document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
};
